import Memory from './Memory';

export { Memory };

export default Memory;
